var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9727 10.0273L9.59375 3.62305C9.53711 3.57422 9.46484 3.54688 9.38867 3.54688H7.66016C7.51563 3.54688 7.44922 3.72656 7.55859 3.82031L14.3984 9.75781H2.96875C2.88281 9.75781 2.8125 9.82812 2.8125 9.91406V11.0859C2.8125 11.1719 2.88281 11.2422 2.96875 11.2422H14.3965L7.55664 17.1797C7.44727 17.2754 7.51367 17.4531 7.6582 17.4531H9.44531C9.48242 17.4531 9.51953 17.4395 9.54688 17.4141L16.9727 10.9727C17.0403 10.9139 17.0945 10.8412 17.1316 10.7597C17.1688 10.6782 17.188 10.5896 17.188 10.5C17.188 10.4104 17.1688 10.3218 17.1316 10.2403C17.0945 10.1588 17.0403 10.0861 16.9727 10.0273Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.b5d3196658cfcd4c71176419060e4eab.svg";
export { ForwardRef as ReactComponent };